import styled, { css } from "styled-components";

// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// Utils
import { getContainerMinHeight, getLottieContainerHeight } from "./utils";
import { slideUp, designElementsTransformScale } from "./animations";

const LOTTIE_CONTAINER_TOP_OFFSET = -28;
const ANIMATION_DURATION = "0.3s";

export const Container = styled.div<{ $secondaryCalloutsExist: boolean; $primaryTextIsLong: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    border-radius: ${({ theme }) => theme.cornerRadius.large};
    min-height: ${props =>
        `calc(
            ${getContainerMinHeight(props.$secondaryCalloutsExist, props.$primaryTextIsLong)} +
                ${LOTTIE_CONTAINER_TOP_OFFSET}px
        )`};
    padding-bottom: ${props =>
        props.$secondaryCalloutsExist ? props.theme.spacing.xLarge : props.theme.spacing.medium};
`;

export const LottieContainer = styled.div<{ $secondaryCalloutsExist: boolean }>`
    width: 100%;
    height: ${props =>
        `calc(${getLottieContainerHeight(props.$secondaryCalloutsExist)} + ${LOTTIE_CONTAINER_TOP_OFFSET}px)`};
    position: relative;
    top: ${LOTTIE_CONTAINER_TOP_OFFSET}px;
`;

export const ContentWrapper = styled.div<{ $show: boolean; $secondaryCalloutsExist: boolean }>`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 ${props => props.theme.spacing.medium};
    padding-bottom: ${props => props.theme.spacing.xLarge};
    width: 100%;
    visibility: ${props => (props.$show ? "visible" : "hidden")};
    z-index: 1;

    > div {
        width: 100%;
    }

    > * {
        animation: ${props =>
            props.$show
                ? css`
                      ${slideUp} ${ANIMATION_DURATION} ease forwards
                  `
                : "none"};
    }
`;

export const Heading = styled(Text)`
    text-align: center;
    margin-bottom: ${props => props.theme.spacing.xSmall};
`;

export const SubHeading = styled(Text)<{ addExtraMarginBottom?: boolean }>`
    text-align: center;
    margin-bottom: ${props => (props.addExtraMarginBottom ? props.theme.spacing.xLarge : props.theme.spacing.medium)};
`;

export const CloseIconContainer = styled.div`
    position: absolute;
    top: ${props => props.theme.spacing.small};
    right: ${props => props.theme.spacing.small};
    z-index: 1;
`;

export const TopLeftDesignElement = styled(Image)<{ startAnimation: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;

    animation: ${props =>
        props.startAnimation
            ? css`
                  ${designElementsTransformScale} ${ANIMATION_DURATION} ease forwards
              `
            : "none"};
`;

export const BottomRightDesignElement = styled(Image)<{ startAnimation: boolean }>`
    position: absolute;
    bottom: 0;
    right: 0;
    transform-origin: bottom right;

    animation: ${props =>
        props.startAnimation
            ? css`
                  ${designElementsTransformScale} ${ANIMATION_DURATION} ease forwards
              `
            : "none"};
`;
